import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ServiceOptionsData } from '../models';

export interface ServiceOptionsSliceState {
  data: ServiceOptionsData;
  loading: boolean;
  error: string | null;
}

const initialState: ServiceOptionsSliceState = {
  data: null,
  loading: false,
  error: null,
};

const serviceOptionsSlice = createSlice({
  name: 'serviceOptions',
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<ServiceOptionsData>) => ({
      ...state,
      data: action.payload,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setError: (state, action: PayloadAction<string | null>) => ({
      ...state,
      error: action.payload,
    }),
    fetchOptions: (state) => ({
      ...state,
      error: null,
      loading: true,
    }),
  },
});

export { serviceOptionsSlice };
